export default "__VITE_ASSET__BQ6qUoQX__"